import getMiningParamsPath from './getMiningParamsPath'

export default getMiningParamsPath
